import React, { createContext, useContext } from "react";
import { Trans } from "react-i18next";
import { GlobalStore } from "../stores/global";

export const GlobalContext = createContext();

export function useGlobalContext() {
  return useContext(GlobalContext);
}

const ContextProvider = props => {
  const { currentCountryCode, structure } = GlobalStore.useState(s => s);

  return (
    <GlobalContext.Provider
      value={{
        Trans
      }}>
      {currentCountryCode && structure ? props.children : null}
    </GlobalContext.Provider>
  );
};

export default ContextProvider;
